import type { AnchorHTMLAttributes, PropsWithChildren } from "react";
import {
  Link as WouterLink,
  Redirect,
  useLocation as useWouterLocation,
  useParams as useWouterParams,
} from "wouter";

export function Link({
  children,
  to,
  ...props
}: PropsWithChildren<AnchorHTMLAttributes<HTMLAnchorElement> & { to: string }>) {
  return <WouterLink href={to} {...props}>{children}</WouterLink>;
}

export function Navigate({ replace = false, to }: { replace?: boolean; to: string }) {
  return <Redirect replace={replace} to={to} />;
}

export function useNavigate() {
  const [, navigate] = useWouterLocation();
  return (to: string, options?: { replace?: boolean }) =>
    navigate(to, { replace: options?.replace });
}

export function useLocation() {
  const [pathname] = useWouterLocation();
  return { pathname, search: window.location.search };
}

export function usePathname() {
  return useWouterLocation()[0];
}

export function useParams<T extends Record<string, string | undefined>>() {
  return useWouterParams<T>();
}
